import React/* , { useState }  */ from "react"
import { Card, Button /* Icon, Header */ } from "semantic-ui-react"
// import { findIndex } from 'lodash'
// import fire from './App/fire';

const ServerStatus = () => {
  // const [isOnline, setIsOnline] = useState(true)
  // let urls

  // fire
  //   .database()
  //   .ref('endpoints')
  //   .orderByKey()
  //   .on('value', snapshot => {
  //     urls = snapshot.val()
  //   })

  // const checkServer = async (url) => {
  //   try {
  //     const result = await fetch(url, {
  //       method: "post",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     })
  //     if (result.status >= 500) {
  //       setIsOnline(false)
  //     }
  //   } catch (err) {
  //     throw new Error(err)
  //   }
  // }

  // if (!urls) {
  //   return (
  //     <Card>
  //       <Card.Content header="Server Status" color="blue" />
  //       <Card.Content>
  //         <Card.Description textAlign="center">
  //           <Icon color="gray" name="warning circle" size="massive" />
  //           <Header as="h5">Loading Server Status...</Header>
  //         </Card.Description>
  //       </Card.Content>
  //     </Card>
  //   )
  // }

  // const index = findIndex(urls, endpoint => endpoint.active)
  // const activeUrl = urls[index]
  // let serverName = ''
  // if (activeUrl) {
  //   checkServer(activeUrl.url)
  //   serverName = activeUrl.name
  // }

  return (
    <Card aas="a" href="https://status.visp.net" target="_blank">
      {/* <Card.Content header="View Server Status" color="blue" textAlign="center" icon="server" /> */}
      <Card.Content>
        <Button content='View server status' icon='server' color='green' fluid />
        {/* <Card.Description textAlign="center">
          <Icon color="black" name="server" size="huge" />
        </Card.Description> */}
        {/* isOnline ? (
          <Card.Description textAlign="center">
            <Icon color="green" name="warning circle" size="massive" />
            <Header.Subheader>{serverName}</Header.Subheader>
            <Header as="h5">Server is Online</Header>
          </Card.Description>
        ) : (
            <Card.Description textAlign="center">
              <Icon color="red" name="warning circle" size="massive" />
              <Header.Subheader>{serverName}</Header.Subheader>
              <Header as="h5">Server is offline</Header>
            </Card.Description>
          ) */}
      </Card.Content>
    </Card>
  )
}

export default ServerStatus
